import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/tipos_proyecto/tipos_proyecto';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.tipos_proyecto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);